import store from "../../../redux/store";

import { processToolResponse } from "./processToolResponse";
import { convertStringToHtmlString } from "./stringMarkdownOpertations";

import fpLog from "../../../utils/fpLog";
import { convertToRefString } from "@/components/ReferenceWrapper/services/convertToRefString";
import removeDetailsFromTableCell from "./removeDetailsFromTableCell";
import addQidInTable from "./addQidInTable";
import { FpAppV4DataType } from "../utils/fpAppV4Interface";

const convertSectionAnswersToHtml = async (qid: string) => {
  const fpAppV4Data = store.getState().fpAppV4Data as FpAppV4DataType;
  const queryAnswer = fpAppV4Data.queryAnswers.find((qa) => qa.qid === qid);

  if (!queryAnswer) return "";

  const sectionResponses = queryAnswer.toolResponse.answer.sectionResponses;
  if (!sectionResponses) return "";

  let htmlContents = [];

  for (const section of sectionResponses) {
    let htmlContent = "";
    const sectionHtmlContent = await convertStringToHtmlString(
      section.response,
      qid
    );
    htmlContent += `<p>${sectionHtmlContent}</p><hr /><p></p>`;
    htmlContent = convertToRefString({
      htmlString: htmlContent,
      qid: qid,
      sourceMap: queryAnswer?.toolResponse?.answer?.sourceMap,
    });

    htmlContents.push(htmlContent);
  }

  return htmlContents;
};

export { convertSectionAnswersToHtml };
